/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  userId: ZodTypes.Id,
});

export const PatchProjectUser = {
  id: 'project-user.patch',
  tag: 'Project',
  summary: 'Update project user',
  description: 'Update a users role within a project',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/user/${params.userId}`,
  request: {
    params: Params,
    body: { content: { 'application/json': { schema: z.strictObject({ role: ZodTypes.RBAC.Project.Roles }) } } },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
